import { observable } from 'mobx';
import {FormInviteModel} from '../../../components/form-invite';
import {createInviteForm} from '../../../lib/form';
import {InviteSchema} from '../../../types/schema';
import {PageAccountInvitesModel} from '../../../components/page-account-invites';
import {Coupon} from '../../../components/user/coupon';

export class AccountCouponsPageModel {
  @observable
  loading: boolean = false;

  @observable
  coupons: Coupon[] = []
}